import 'css-chunksrc/client/common/scrollPane/styles.scss';export default {
  "scrollPane": "_scrollPane_1colg_1"
};